import { useEffect } from 'react'
import config from 'config'
import { injectHelplyWidget } from 'util/helplyWidget'
import useHelplyWidgetEnabled from 'util/hooks/useHelplyWidgetEnabled'

/** Puts the Helply widget on the page for the accounts it is on for (`useHelplyWidgetEnabled`); renders nothing. */
const HelplyWidgetLoader = () => {
  const { widget } = useHelplyWidgetEnabled()
  useEffect(
    () => {
      if (widget) injectHelplyWidget(config.helplyWidget)
    },
    [widget]
  )
  return null
}

export default HelplyWidgetLoader
